export type PlanCode = (typeof PLAN_CODES)[keyof typeof PLAN_CODES];

export type MembershipPlan =
  (typeof MEMBERSHIP_PLANS)[keyof typeof MEMBERSHIP_PLANS];

export const PLAN_CODES = {
  NO_RENEW: 'wd_annual',
  RENEW: 'wd_annual_recurring',
  PRO_MONTHLY: 'wd_pro_monthly',
  PRO_YEARLY: 'wd_pro_yearly',
  PRO_IAP_MONTHLY: 'wd_pro_monthly_iap',
  PRO_IAP_YEARLY: 'wd_pro_yearly_iap',
  IAP_YEARLY: 'wd_annual_recurring_membership',
  RECURLY_IAP_YEARLY: 'wd_annual_recurring_iap',
} as const;

export const MEMBERSHIP_PLANS = {
  yearly: 'yearly',
  proYearly: 'pro_yearly',
  proMonthly: 'pro_monthly',
} as const;

export const MEMBERSHIP_PLANS_AMOUNTS: Record<MembershipPlan, number> = {
  [MEMBERSHIP_PLANS.yearly]: 24.99,
  [MEMBERSHIP_PLANS.proYearly]: 99.99,
  [MEMBERSHIP_PLANS.proMonthly]: 29.99,
} as const;

export const PLAN_CODE_TO_MEMBERSHIP_PLAN: Record<PlanCode, MembershipPlan> = {
  [PLAN_CODES.RENEW]: MEMBERSHIP_PLANS.yearly,
  [PLAN_CODES.NO_RENEW]: MEMBERSHIP_PLANS.yearly,
  [PLAN_CODES.PRO_YEARLY]: MEMBERSHIP_PLANS.proYearly,
  [PLAN_CODES.PRO_MONTHLY]: MEMBERSHIP_PLANS.proMonthly,
  [PLAN_CODES.PRO_IAP_YEARLY]: MEMBERSHIP_PLANS.proYearly,
  [PLAN_CODES.PRO_IAP_MONTHLY]: MEMBERSHIP_PLANS.proMonthly,
  [PLAN_CODES.IAP_YEARLY]: MEMBERSHIP_PLANS.yearly,
  [PLAN_CODES.RECURLY_IAP_YEARLY]: MEMBERSHIP_PLANS.yearly,
} as const;
